import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip } from "chart.js";

let isRegistered = false;

/** Registers Chart.js modules once for chart components. */
export function registerCharts() {
    if (isRegistered) return;

    ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);
    isRegistered = true;
}
